module.exports = __webpack_public_path__ + "img/Icon EDV.affa6128.svg";